// import FazendaContainer from './views/fazendaContainer';
import FazendaContainer from './views/fazendaContainer';
export { default as FazendasCheckbox } from './views/fazendasCheckbox';
export { default as FazendaManager } from './fazendaManager';
export default FazendaContainer;
// export default FazendaContainer;
